import { decamelizeKeys } from 'humps';
import resolve from '../../../../api-client';

import {
  getParticipantEmailUrl,
  getParticipantResetUrl,
  getParticipantImpressionUrl,
} from '../../util';

import {
  PARTICIPANT__AUTHORIZE_IN_PREVIEW,
  PARTICIPANT__CREATE_IMPRESSION,
  PARTICIPANT__RESET,
  PARTICIPANT__USE_EMAIL,
} from '../constants';

export const authorizeInPreviewMode = (provider) => ({
  type: PARTICIPANT__AUTHORIZE_IN_PREVIEW,
  data: {
    firstName: 'Preview',
    provider: `${provider}`,
    authorizedInPreview: true,
  },
});

export const participantCreateImpression = ({ pageId, token }) =>
  resolve({
    data: decamelizeKeys({
      pageId,
      token,
    }),
    method: 'post',
    type: PARTICIPANT__CREATE_IMPRESSION,
    url: getParticipantImpressionUrl(),
    retry: 2,
  });

export const participantReset = (token) =>
  resolve({
    data: decamelizeKeys({
      token,
    }),
    method: 'post',
    type: PARTICIPANT__RESET,
    url: getParticipantResetUrl(),
    retry: 3,
  });

export const participantUseEmail = ({ token, email, firstName, lastName }) =>
  resolve({
    data: decamelizeKeys({
      email,
      firstName,
      lastName,
      token,
    }),
    method: 'post',
    type: PARTICIPANT__USE_EMAIL,
    url: getParticipantEmailUrl(),
    retry: 3,
  });
